/**
 * Formats a time value in seconds to a string with millisecond precision
 * @param time - Time in seconds
 * @returns Formatted time string (e.g., "01:23.456")
 */
export const formatTimeWithMilliseconds = (time: number): string => {
  if (!time || isNaN(time)) return '00:00.000';

  const totalSeconds = Math.floor(time);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = Math.floor((time - totalSeconds) * 1000);

  const formatDecimal = (val: number) => (val > 9 ? val : '0' + val);
  const formatMilliseconds = (val: number) => val.toString().padStart(3, '0');

  return `${formatDecimal(minutes)}:${formatDecimal(seconds)}.${formatMilliseconds(milliseconds)}`;
};
